import { getWebsiteFrontendFlags } from '@va/dashboard/selectors/core';

export const hasCompletedFeatureTour = (state: any, featureKeyFlag: string) => {
  const flags = getWebsiteFrontendFlags(state);
  return !!flags[featureKeyFlag];
};
